// base nav link off white
export const navLinkCls = "nav-link nav-link-avatar link-sfp-light"
// nav badge
export const navBadgeCls = "badge badge-sm badge-rounded rounded-pill bg-warning text-dark"
// top navigation link
export const topLinkCls = "nav-link link-sfp-light"